<div class="alert info lightest">
  <div class="icon icon-info icon-md"></div>
  <p class="alert-content layout flex auto-flow">
    <span class="fill">
      {{ message() }}
    </span>
    @if (actionLabel() && actionLink()) {
      <a
        class="button sm primary fmax-content self-start"
        [routerLink]="actionLink()">
        {{ actionLabel() }}
      </a>
    } @else if (actionLabel() && actionFn()) {
      <button
        class="button sm primary fmax-content self-start"
        (click)="actionFn()!()">
        {{ actionLabel() }}
      </button>
    }
  </p>
</div>
